const sc = {
  greeting: '欢迎您',
  label_btn_details: '详细内容',
  pagination: {
    First: '«',
    Prev: '上一页',
    Next: '下一页',
    Last: '»',
  },
  pagenotfound: {
    title: '找不到网页',
    desc: '很抱歉，您寻找的网页暂时未能显示。',
  },
  header_bar: {
    link_home: {
      name: '香港贸发局网站',
      url: 'https://www.hktdc.com/sc/',
    },
    link_about: {
      name: '关於香港贸发局',
      url: 'http://aboutus.hktdc.com/sc',
    },
    title_login: '登入',
    title_logout: '登出',
    title_edit_profile: '编辑用户资料',
    title_register: '注册',
    title_myhktdc: '我的HKTDC',
    txt_back: '返回',
    link_myhktdc: 'https://home.hktdc.com/sc/myhktdc',
  },
  speaker: {
    popup: {
      remark: '* For high-resolution photos, please click the images.',
    },
  },
  under_construction: {
    text: '将于稍后公布。',
  },
  loading: '载入中',
  search: {
    placeholder: '参展商/ 供应商/ 产品/ 展位编号/ 品牌',
    validation: '请输入关键字!',
  },
  sbeProgramme: {
    venue: '地点',
    language: '语言',
    remarks: '备注',
    hkTimezone: 'HKT',
  },
  photo: {
    view: '预览',
    download: '下载',
  },
  video: {
    date: '日期',
    duration: '影片长度',
    close: '关闭',
  },
};

export default sc;
